import styled from 'styled-components'

export const BoxComponent = styled.div`
  background-color: ${({ theme }) => theme._neo.ui02};
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  height: 150px;
  overflow: hidden;
  padding: 16px;
  position: relative;

  &:hover {
    background-color: ${({ theme }) => theme._neo.ui01};
  }

  &:focus, &:focus-visible {
    outline: 2px solid ${({ theme }) => theme._neo.focus01};
    outline-offset: -2px;
  }
`
